<div class="col-12" *ngIf="gridload">
  <app-busy [message]="message"></app-busy>
</div>
<div class="container-fluid">
  <div class="row">
    <div class="col-9">
      <h5 class=""><i class="fa fa-search" aria-hidden="true"></i><b>&nbsp;Permit Enquiry</b>
       </h5>
    </div>
 
  </div>
  <hr>
      
        <br>
       
        <div class="col-md-12">
          <app-filter></app-filter>
      </div>
          <div class="cover-x pull-right">
            <div class="main-btn rounded-circle rmp-all" id="btnReset" (click)="reset()" title="Reset filters..." style="margin: 0px auto!important;display: none;" rel="tooltip" data-placement="top">
              <span class="fa fa-undo fa-2x" style="margin:5.5px auto;color:white!important;" aria-hidden="true"></span>
            </div>
          </div>
          <div class="cover-x">
            <div class="main-btn rounded-circle rmp-all" id="btnSearch" (click)="onSearch()" title="Apply filters..." style="margin: 0px auto!important;display: none;" rel="tooltip" data-placement="top">
              <span class="fa fa-search fa-2x" style="margin:5.5px auto;color:white!important;" aria-hidden="true"></span>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <!-- <ngx-loading [show]="gridload"></ngx-loading> -->

              <table class="table table-sm table-striped">
                <thead>
                  <tr>
                    <th rowspan="2" style="min-width:100px !important;">Account Number<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(1)"></i></th>
                    <th rowspan="2"  title="permit type description">Permit Number<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(2)"></i></th>
                   
                    <th rowspan="2">Type<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(3)"></i></th>
                    <th rowspan="2">Start<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(4)"></i></th>
                    <th rowspan="2"></th>
                    <th rowspan="2">End<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(5)"></i></th>
                    <th rowspan="2">Status<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(6)"></i></th>
                 <!--   <th colspan="2">Vehicle</th>-->
                    <th rowspan="2">Vehicle Type<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(7)"></i></th>
                    <th rowspan="2">Registration No<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(8)"></i></th>
                    <!-- <th rowspan="2"> Dropdown Menu</th> -->
                  </tr>
                  <tr>
                    <!-- <th>Type<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(8)"></i></th>
                    <th>Registration<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(9)"></i></th> -->
                  </tr>
                  
                </thead>
                <tbody>
                  <tr
                  *ngFor="let item of permits | orderBy: utility.criteria : utility.direction | paginate: { itemsPerPage: pageSize, currentPage: pageNumber, id: 'apps', totalItems: Count }, let i=index">
                  <ng-container>
                    <td title="{{item.Name}}">
                      <a [routerLink]="['/carrier/account/edit/' + item.carrier.id + '/1' ]" style="color:#00008b; text-decoration: underline;"><span title ="View account details">{{item.AccountNumber}}</span></a>  
                    </td>
                  <td>
                    <div class="row" *ngFor="let perm of item.Permit">
                      <a  [routerLink]="['/carrier/permit/application/view/' + perm.application_id + '/' + perm.permit_issue]" style="color:#00008b; text-decoration: underline;">
                        <span title ="View permit details">
                        {{perm.permit_num}} /
                        {{perm.permit_issue}}                    
                      </span>
                    </a>      
                  </div>              
                  </td>
                   
                    <td  title="{{item.PermitType}}">
                      <div class="row">
                        <span>
                          {{item.PermitType}}
                        </span>
                      </div>
                    </td>
                    <td >
                      <div class="row" *ngFor="let perm of item.Permit">
                        <span *ngIf="perm.date_valid_from!=null">{{perm.date_valid_from | date:'dd/MM/yyyy'}}</span>
                      </div>
                    </td>
                    <td>&nbsp;</td>
                    <td>
                      <div class="row" *ngFor="let perm of item.Permit">
                        <span *ngIf="perm.date_valid_to!=null">{{perm.date_valid_to | date:'dd/MM/yyyy'}}</span>
                      </div>
                    </td>
                    <td ><span *ngIf="item.status_id!=null">{{item.status}}</span></td>
                    <td >
                      <div class="row" *ngFor="let perm of item.Permit">
                         <span>{{perm.vehicle_type}}</span>
                      </div>
                    </td>
                    <td>
                      <div class="row" *ngFor="let perm of item.Permit">
                        <span>{{perm.vehicle_reg_num}}</span>
                      </div>
                    </td>
                   
                   
                    <!-- <td ><span *ngIf="item.Route!=null">{{item.Route.code}}</span></td>
                    <td><span *ngIf="item.submission_date!=null">{{item.submission_date | date:'dd/MM/yyyy'}}
                    </span>
                    </td> -->
                  </ng-container>
                    <!-- <td>
                        <select class="form-control" (change)="navigatePermit(item,change)" id="selectControl" #change>
                            <option value="">Select</option>
                            <option class="app-option" disabled value="myNum">Duplicate</option>
                            <option class="app-option" disabled value="myNum">Change Owner</option>
                            <option class="app-option" disabled value="myNum">Change Route</option>
                            <option class="app-option" disabled value="myNum">Change Timetable</option>
                            <option class="app-option" disabled value="myNum">Change Vehicle</option>
                            <option class="app-option" disabled value="myNum">Upload Passenger Lists</option>
                            <option class="app-option" disabled value="myNum">Upload Consignment Notes</option>
                            <option value="renew" *ngIf="item.status_id!=1 && item.status_id!=11 && item.listRes.permit_type.temp_long_ind==2 && item.listRes.permit.is_valid">Renew Permit</option>
                            
                            
                        </select>
                    </td> -->
                  </tr> 
                </tbody>
              </table>
              
              <div style="text-align:center" *ngIf="Count >= 5">
                <table border="0" cellpadding="0" cellspacing="0" style="float: right;">
                  <tr>
                    <td style="white-space:nowrap;font-weight:bold;padding-right:3px">
                      Show :
                    </td>
                    <td style="white-space: nowrap">
                      <select style="cursor:pointer" [(ngModel)]="pageSize" (ngModelChange)="pageSizeChange()">
                        <option *ngFor="let size of pageSizes()" [ngValue]="size"> {{pageSizeName(size)}} </option>
                      </select>
                    </td>
                  </tr>
                </table>
                <pagination-controls class="my-pagination" (pageChange)="pageNumber = onPage($event)" id="apps"></pagination-controls>            
              </div>

              <div>
                <tfoot>
                  <tr *ngIf="isEmpty">
                    <td colspan="9" class="rm-brd">
                      <span class="text-info text-small; color:black">No permits found.</span>
                    </td>
                  </tr>

                </tfoot>

              </div>
              <!--<div style="text-align:center" *ngIf="permits.length <= 0">
                <h5>no permits found</h5>
              </div>-->
            </div>         
          </div>
    <div>
        <!-- <div class="card-data">
            <div class="col-md-12">
                <button title="Back" type="button" id="btnBack" (click)="onBack()" class="btn btn-md btn-primary pull-right" style="margin-left:10px; ">Back</button>
              </div>
        </div> -->
    </div>
</div>